import padStart from 'lodash/padStart';

function makeRow(lineNo: number, type: '=' | '+' | '-', text: string) {
  if (type == '+') return `\n${padStart(lineNo.toString(), 4, ' ')} + ${text}`;
  if (type == '-') return `\n${padStart(lineNo.toString(), 4, ' ')} - ${text}`;
  return '';
}

function getDiff(
  matrix: number[][],
  l1: string[],
  l2: string[],
  x: number,
  y: number,
): string {
  if (x > 0 && y > 0 && l1[y - 1] === l2[x - 1]) {
    return getDiff(matrix, l1, l2, x - 1, y - 1);
  }
  if (x > 0 && (y === 0 || matrix[y][x - 1] >= matrix[y - 1][x])) {
    return getDiff(matrix, l1, l2, x - 1, y) + makeRow(x, '+', l2[x - 1]);
  }
  if (y > 0 && (x === 0 || matrix[y][x - 1] < matrix[y - 1][x])) {
    return getDiff(matrix, l1, l2, x, y - 1) + makeRow(y, '-', l1[y - 1]);
  }

  return '';
}

export function textDiff(t1: string, t2: string): string {
  const lines1 = t1.split('\n');
  const lines2 = t2.split('\n');
  const matrix = new Array(lines1.length + 1);
  let x = 0;
  let y = 0;

  for (y = 0; y < matrix.length; y++) {
    matrix[y] = new Array(lines2.length + 1);

    for (x = 0; x < matrix[y].length; x++) {
      matrix[y][x] = 0;
    }
  }

  for (y = 1; y < matrix.length; y++) {
    for (x = 1; x < matrix[y].length; x++) {
      if (lines1[y - 1] === lines2[x - 1]) {
        matrix[y][x] = 1 + matrix[y - 1][x - 1];
      } else {
        matrix[y][x] = Math.max(matrix[y - 1][x], matrix[y][x - 1]);
      }
    }
  }

  return getDiff(matrix, lines1, lines2, x - 1, y - 1);
}
